class EmailPopup extends HTMLElement {
  constructor() {
    super();

    this.storageKey = 'gaf:email-popup:dismissed-until';
    this.overlay = this.querySelector('.email-popup__overlay');
    this.inner = this.querySelector('.email-popup__inner');
    this.closeButton = this.querySelector('.email-popup__close');

    this.overlay.addEventListener('click', this.close.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());

    const form = this.querySelector('form');
    if (form) form.addEventListener('submit', () => this.dismissFor(365));

    if (this.querySelector('[aria-invalid="true"]')) {
      this.open();
      return;
    }

    if (this.querySelector('[data-popup-success]')) {
      this.dismissFor(365);
      this.open();
      this.timeoutId = setTimeout(() => this.close(), 4000);
      return;
    }

    if (this.isDismissed()) return;

    const delay = parseInt(this.dataset.delay, 10) || 0;
    this.timeoutId = setTimeout(() => this.open(), delay);
  }

  isDismissed() {
    const dismissedUntil = parseInt(window.localStorage.getItem(this.storageKey), 10);
    return Boolean(dismissedUntil) && Date.now() < dismissedUntil;
  }

  dismissFor(days) {
    const dismissedUntil = Date.now() + days * 24 * 60 * 60 * 1000;
    window.localStorage.setItem(this.storageKey, dismissedUntil);
  }

  open() {
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
    trapFocus(this.inner, this.inner.querySelector('input:not([type="hidden"])'));
  }

  close() {
    if (this.timeoutId) clearTimeout(this.timeoutId);
    if (!this.querySelector('[data-popup-success]')) {
      const reshowAfter = parseInt(this.dataset.reshowAfter, 10) || 30;
      this.dismissFor(reshowAfter);
    }
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus();
  }
}

customElements.define('email-popup', EmailPopup);
